export default function PremiumLoader() {
  return (
    <>
      <style>{`
        .loader-wrapper {
          width: 100%;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: radial-gradient(circle at top, #f3f6ff, #e2e6f3);
          font-family: 'Segoe UI', sans-serif;
        }

        .loader-card {
          padding: 50px 60px;
          border-radius: 22px;
          background: rgba(255, 255, 255, 0.55);
          backdrop-filter: blur(14px);
          box-shadow: 
            0 30px 60px rgba(0, 0, 0, 0.12),
            inset 0 0 0 1px rgba(255, 255, 255, 0.6);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .wave {
          display: flex;
          gap: 8px;
          margin-bottom: 30px;
        }

        .wave span {
          width: 10px;
          height: 45px;
          background: linear-gradient(180deg, #6a5cff, #9f7aea);
          border-radius: 6px;
          animation: waveMove 1.2s infinite ease-in-out;
        }

        .wave span:nth-child(1) { animation-delay: 0s; }
        .wave span:nth-child(2) { animation-delay: 0.1s; }
        .wave span:nth-child(3) { animation-delay: 0.2s; }
        .wave span:nth-child(4) { animation-delay: 0.3s; }
        .wave span:nth-child(5) { animation-delay: 0.4s; }

        @keyframes waveMove {
          0%, 100% {
            transform: scaleY(0.5);
            opacity: 0.5;
          }
          50% {
            transform: scaleY(1.4);
            opacity: 1;
          }
        }

        .loader-text {
          font-size: 22px;
          font-weight: 600;
          color: #4a4a68;
          letter-spacing: 1px;
          animation: shimmer 2s infinite;
        }

        @keyframes shimmer {
          0% { opacity: 0.5; }
          50% { opacity: 1; }
          100% { opacity: 0.5; }
        }

        @media (max-width: 600px) {
          .loader-card {
            padding: 40px 35px;
          }

          .loader-text {
            font-size: 18px;
          }

          .wave span {
            height: 35px;
          }
        }
      `}</style>

      <div className="loader-wrapper">
        <div className="loader-card">
          <div className="wave">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="loader-text">Loading, please wait…</div>
        </div>
      </div>
    </>
  );
}
